module.exports = __webpack_public_path__ + "img/eyein-partner-cogeco.cebfbb61.png";